import { useState } from 'react';
import { Button } from '@/components/ui/button.tsx';

import LoaderWithBackdrop from '@/components/custom/LoaderWithBackdrop';
import PageWrapper from '@/components/atoms/PageWrapper';
import { BackNav, NavigationBarBreadCrumbs } from '@/components/molecules/BackNav';
import { useUserData } from "@/lib/useQuery/user/useUserData";

import BasicDataModal from './BasicDataModal';
import UpdatePasswordModal from './UpdatePasswordModal';

export default function Settings() {
  const { data: userData } = useUserData();

  const [showBasicDataModal, setShowBasicDataModal] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);

  const showDataModal = () => {
    setShowBasicDataModal(true);
  }
  const hideDataModal = () => {
    setShowBasicDataModal(false);
  }
  const showPasswordDataModal = () => {
    setShowPasswordModal(true);
  }
  const hidePasswordDataModal = () => {
    setShowPasswordModal(false);
  }

  return (
    <>
      {false && (<LoaderWithBackdrop />)}

      <BasicDataModal
        show={showBasicDataModal}
        onHide={hideDataModal}
      />

      <UpdatePasswordModal
        show={showPasswordModal}
        onHide={hidePasswordDataModal}
      />

      <PageWrapper className="flex-col">
        <div className="px-1 m-0 overflow-hidden flex flex-col grow-1 flex-nowrap" style={{ minHeight: 'calc(100vh - 98px)' }}>
          <NavigationBarBreadCrumbs.Set
            currentPageName="Settings"
            pages={[
              {
                title: "Home",
                goTo: "/welcome"
              }
            ]}
          />
          {/* <BackNav
                  currentPageName="Settings"
                  pages={[
                      {
                          title: "Home",
                          goTo: "/welcome"
                      }
                  ]}
              /> */}

          <h1 className="mb-1 text-xl font-medium">Basic Data</h1>
          <hr className="my-3" />

          <div className="flex flex-col justify-between space-y-4 sm:flex-row sm:items-center">
            <div>
              <p className="text-sm">First Name: <b>{userData?.first_name || "-"}</b></p>
              <p className="text-sm">Last Name: <b>{userData?.last_name || "-"}</b></p>
              <p className="text-sm">Email: <b>{userData?.email || "-"}</b></p>
            </div>
            <div>
              <div className="w-full sm:max-w-32">
                <Button size="sm"
                  type="submit"
                  className="w-100"
                  onClick={showDataModal}
                >
                  Update
                </Button>
              </div>
            </div>
          </div>
          <hr className="my-3" />
          <div className="flex flex-col justify-between space-y-4 sm:flex-row sm:items-center">
            <h1 className="mb-1 text-xl font-medium">Password</h1>
            <div>
              <div className="w-full sm:max-w-32">
                <Button size="sm"
                  type="submit"
                  className="w-100"
                  onClick={showPasswordDataModal}
                >
                  Change Password
                </Button>
              </div>
            </div>
          </div>
        </div>
      </PageWrapper>
    </>
  );
}
